import _ from 'lodash'
import { enums } from '@adc/sdk'
import fetch from '@adc/fetch'
import configment from '@adc/configment'
import { constraints } from '@adc/constants'

export const MAX_PERSONAL_SAVED_SEARCHES = 100

const getSavedSearches = async (req, tableType) => {
  const res = await fetch(
    `${configment.get('RESI_MS_PROFILE')}/resi/profile/v1/saved-searches`,
    {
      req,
      queryParams: {
        source: 'MORPHEUS',
        namespace: tableType,
        size: constraints.BACKEND_MAX_PAGE_SIZE,
      },
    }
  )
  return res.body.content
}

const postSavedSearch = async (req, values) => {
  return fetch
    .forAuctionGraph({
      query: `
        mutation btbSync_saveSearch ($searchInput: SaveSearchInput!) {
          saveSearch(input: $searchInput) {
            saved_search_id
            parameters
            data_source_code
            email_alert_type
            namespace
            param_version
            saved_search_name
            saved_search_type
            subscribed_to_notifications
          }
        }
      `,
      variables: {
        searchInput: {
          data_source_code: enums.SavedSearchSource.Morpheus,
          email_alert_type: 'NONE',
          subscribed_to_notifications: false,
          param_version: values.param_version || 1,
          parameters: values.parameters || {},
          saved_search_name: values.saved_search_name,
          saved_search_type: values.saved_search_type || 'PERSONAL',
          namespace: values.namespace,
        },
      },
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res
    })
    .then(res => _.get(res, 'body.data.saveSearch', {}))
}

const putSavedSearch = async (req, values) => {
  return fetch
    .forAuctionGraph(
      {
        query: `
        mutation btbSync_updateSearch ($updateSearchInput: UpdateSearchInput!) {
          updateSavedSearch(input: $updateSearchInput) {
            saved_search_id
            saved_search_name
            saved_search_type
            parameters
          }
        }
      `,
        variables: {
          updateSearchInput: {
            data_source_code: enums.SavedSearchSource.Morpheus,
            email_alert_type: 'NONE',
            subscribed_to_notifications: false,
            param_version: values.param_version || 1,
            parameters: values.parameters || {},
            saved_search_name: values.saved_search_name,
            saved_search_type: values.saved_search_type,
            saved_search_id: values.saved_search_id,
            namespace: values.namespace,
          },
        },
      },
      { req }
    )
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res
    })
    .then(res => _.get(res, 'body.data.updateSavedSearch', {}))
}

const deleteSavedSearch = async (req, id) => {
  return fetch
    .forAuctionGraph(
      {
        query: `
      mutation btbSync_deleteSearch ($deleteSearchInput: DeleteSearchInput!) {
        deleteSearch(input: $deleteSearchInput)
      }
      `,
        variables: {
          deleteSearchInput: {
            saved_search_id: id,
          },
        },
      },
      { req }
    )
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res
    })
    .then(res => _.get(res, 'body.data.deleteSearch', {}))
}

const savedSearchProviders = {
  getSavedSearches,
  putSavedSearch,
  postSavedSearch,
  deleteSavedSearch,
}

export { savedSearchProviders }
